module.exports = __webpack_public_path__ + "img/benjike2.cd4ef056.png";